module.exports = __webpack_public_path__ + "static/taiaoentryform-5fa8194ab7ab61aee24c9118a91e6eb6.pdf";